import React, {useEffect} from 'react';
import {Helmet} from "react-helmet";
import {
  Link, useLocation,
} from "react-router-dom";

import {connect} from 'react-redux';
// import {Actions as MYACTIONS} from './store/actions/myActions';
// import {Actions as TEAMACTIONS} from './store/actions/teamActions';
// import {Actions as AUTHENTICATIONACTIONS} from './store/actions/authenticationActions';
import RegistrationForm from 'components/common/RegistrationForm'
import FeaturesSideBySide from 'components/features/FeaturesSideBySide'
import MaltaFeatures from 'components/features/MaltaFeatures'
import Team from 'components/team/Team'
import Pricing from 'components/pricing/Pricing'
import Testimonials from 'components/testimonials/Testimonials'
import Security from 'components/security/Security'


import MaltaFlag from 'assets/flags/malta.svg';

import TeddiesChildcareLogo from 'assets/images/childcare/teddies-childcare.png';
import LilVilleLogo from 'assets/images/childcare/lil-ville.png';
import SmartFromTheStart from 'assets/images/childcare/smart-from-the-start.png';
import childcareFade from 'assets/images/childcare/childcare-fade.webp'; //png?


function Home({

}) {

    const location = useLocation()

    const countryCode = location.pathname.split('/')[1]
    const country = ['uk', 'mt', 'ie'].includes(countryCode) ? countryCode: null


  return (

    <React.Fragment>

      <Helmet>
          <title>Childcare Payroll - Buddy HR</title>
        <meta name="description" content="Your childcare business may be able to save thousands of euros in payroll costs. With Buddy Payroll Software, You can track employee payments, make deductions, and handle payroll tax payments." />
          <link rel="canonical" href={`https://www.buddy.hr/childcare-payroll`} />
      </Helmet>
      <main className="pt-8 sm:pt-16 md:pt-20 lg:mb-24 pb-8 sm:pb-16 md:pb-20 lg:pb-24"
          style={{
            backgroundImage: `url(${childcareFade})`,
            backgroundPosition: "top left",
            backgroundSize: "78%",
            backgroundRepeat: "no-repeat",
          }}
        >
        <div className="mx-auto max-w-screen-xl">
          <div className="lg:grid lg:grid-cols-12 lg:gap-8">
            <div className="px-4 sm:px-6 sm:text-center md:max-w-2xl md:mx-auto lg:col-span-6 lg:text-left lg:flex lg:items-center">
              <div>
                <h1 className="mt-4 text-4xl tracking-tight leading-10 font-extrabold text-white sm:mt-5 sm:leading-none sm:text-6xl lg:mt-6 lg:text-5xl xl:text-6xl">
                  <span className="text-orange-400">Childcare Payroll</span>
                  <br className="hidden md:inline"/>
                  <span className="text-3xl sm:text-5xl lg:text-4xl xl:text-5xl">has never been easier</span>
                </h1>
                <p className="mt-3 text-base text-gray-300 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl">
                  Buddy sets your childcare business for success with our easy to use HR and payroll functions.
                  From leave management to calculating pay based on your timesheets, Buddy does all the hard work, so you can focus on growing your Childcare business.
                </p>
                <p className="mt-8 text-sm text-white uppercase tracking-wide font-semibold sm:mt-10">Used by</p>
                <div className="mt-5 w-full sm:mx-auto sm:max-w-lg lg:ml-0">
                  <div className="flex flex-wrap items-start justify-between">
                    <div className="flex justify-center px-1">
                      <img className="h-15 sm:h-20" src={TeddiesChildcareLogo} alt="Teddies Childcare Centre"/>
                    </div>
                    <div className="flex justify-center px-1">
                      <img className="h-15 sm:h-20" src={LilVilleLogo} alt="Lil' Ville"/>
                    </div>
                    <div className="flex justify-center px-1">
                      <img className="h-15 sm:h-20" src={SmartFromTheStart} alt="Smart From The Start"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-12 sm:mt-16 lg:mt-0 lg:col-span-6">
              <RegistrationForm jurisdiction={country?.toUpperCase()}/>
            </div>
          </div>
        </div>
      </main>

      <div className="bg-white">
        <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:py-24 lg:px-8">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-3xl font-extrabold text-gray-900">Payroll Challenges faced by Childcare Centers</h2>
            <p className="mt-4 text-lg text-gray-500">Most childcare centers face these challenges month after month</p>
          </div>
          <dl className="mt-12 space-y-10 sm:space-y-0 sm:grid sm:grid-cols-2 sm:gap-x-6 sm:gap-y-12 lg:grid-cols-4 lg:gap-x-8">
            <div className="relative">
              <dt>
                <svg className="absolute w-6 h-6 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                <p className="ml-9 text-lg leading-6 font-medium text-gray-900">Collecting Timesheets</p>
              </dt>
              <dd className="mt-2 ml-9 text-base text-gray-500">
                Using old-school pen and paper or punch clocks that give you reports you hardly understand...
              </dd>
            </div>

            <div className="relative">
              <dt>
                <svg className="absolute w-6 h-6 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                <p className="ml-9 text-lg leading-6 font-medium text-gray-900">Tallying Timesheets</p>
              </dt>
              <dd className="mt-2 ml-9 text-base text-gray-500">
                You have to tally up hours from your excel timesheets to send to your accountant.
              </dd>
            </div>

            <div className="relative">
              <dt>
                <svg className="absolute w-6 h-6 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                <p className="ml-9 text-lg leading-6 font-medium text-gray-900">Leave Management</p>
              </dt>
              <dd className="mt-2 ml-9 text-base text-gray-500">
                Managing holidays using paper or excel sheets is a nightmare risking ending up understaffed.
              </dd>
            </div>

            <div className="relative">
              <dt>
                <svg className="absolute w-6 h-6 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                <p className="ml-9 text-lg leading-6 font-medium text-gray-900">Leave Balances</p>
              </dt>
              <dd className="mt-2 ml-9 text-base text-gray-500">
                With employees working variable hours, you never quite know how much leave anyone is entitled to.
              </dd>
            </div>

            <div className="relative">
              <dt>
                <svg className="absolute w-6 h-6 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                <p className="ml-9 text-lg leading-6 font-medium text-gray-900">Changing Regulations</p>
              </dt>
              <dd className="mt-2 ml-9 text-base text-gray-500">
                Tax, social security, benefits, leave regulations, COVID-19 Supplement...
              </dd>
            </div>

            <div className="relative">
              <dt>
                <svg className="absolute w-6 h-6 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                <p className="ml-9 text-lg leading-6 font-medium text-gray-900">Payslip Questions</p>
              </dt>
              <dd className="mt-2 ml-9 text-base text-gray-500">
                Employees are always querying or doubting the payslips and how the numbers add up.
              </dd>
            </div>

            <div className="relative">
              <dt>
                <svg className="absolute w-6 h-6 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                <p className="ml-9 text-lg leading-6 font-medium text-gray-900">Employee Requests</p>
              </dt>
              <dd className="mt-2 ml-9 text-base text-gray-500">
                Requests for lost payslips, leave balances, FS3s, updating of details... all eat into your time.
              </dd>
            </div>

            <div className="relative">
              <dt>
                <svg className="absolute w-6 h-6 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                <p className="ml-9 text-lg leading-6 font-medium text-gray-900">FSS Submission Nightmares</p>
              </dt>
              <dd className="mt-2 ml-9 text-base text-gray-500">
                Every year you have to chase your accountant to create the FS3s, FS7 &amp; FSS submission files
              </dd>
            </div>
          </dl>
          <div className="text-6xl text-center mt-15">🤯</div>
        </div>
      </div>

      <FeaturesSideBySide/>
      <MaltaFeatures/>
      <Pricing/>
      <Testimonials/>
      <Security/>
      <Team/>

      <div className="bg-orange-600">
        <div className="max-w-2xl mx-auto text-center py-16 px-4 sm:py-20 sm:px-6 lg:px-8">
          <h2 className="text-3xl leading-9 font-extrabold text-white sm:text-4xl sm:leading-10">
            <span className="block">Forget your payroll pains.</span>
            <span className="block">Book a FREE Consult today.</span>
          </h2>
          <p className="mt-4 text-lg leading-6 text-orange-200">Talk to one of our payroll experts <br/>and see how you can improve your payroll process.</p>
          <a href="https://calendly.com/buddy-intro/buddy-introduction-meeting" className="mt-8 w-full inline-flex items-center justify-center px-5 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-orange-600 bg-white hover:text-orange-500 hover:bg-orange-50 transition duration-150 ease-in-out sm:w-auto">
            Book my spot
          </a>
        </div>
      </div>

    </React.Fragment>
    
  );
}

const mapStateToProps = (state) => {

  // const {
  //   myAgreements,
  // } = state.my


  return {
    // showSidebar: state.sidebar.show,
    // loggedIn: state.my.profile ? true : false,
  }
}

const mapDispatchToProps = dispatch => ({
  // myGetAgreements: () => dispatch(MYACTIONS.myGetAgreements()),
  // getProfile: () => dispatch(MYACTIONS.getProfile()),
  // isLoggedIn: () => dispatch(AUTHENTICATIONACTIONS.isLoggedIn()),
  // getDepartments: () => dispatch(TEAMACTIONS.getDepartments()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Home) 
